function variantPicker(){
  const productRelated = document.querySelector('product-recommendations.related-products');
  
  function handleProductVariants(target = document) {
    const botones_Tallas = target.querySelectorAll('input[data-name="Tallas"]');
    botones_Tallas.forEach(function (boton, idx) {
      boton.classList.add('initialized');
      const variants = JSON.parse(
        boton.closest("variant-radios-card").querySelector("script").textContent
      );
      boton.addEventListener("click", function (element) {
        let Tallas, color;
        const labels = element.currentTarget.closest('fieldset').querySelectorAll('label');
        labels.forEach(label => {
          if (label && label.title == boton.value) {
            const labelSpinner = label.querySelector('span.loader-letter');
            console.log(labelSpinner);
            if (labelSpinner.classList.contains('hidden')) {
              labelSpinner.classList.remove('hidden');
              setTimeout(() => {
                labelSpinner.classList.add('hidden');
              }, 3000);
            }else{
              console.log('no entro')
            }
          }
        });
        Tallas = boton.closest("variant-radios-card").querySelector('input[data-name="Tallas"]:checked')?.value;
        color = boton.closest("variant-radios-card").querySelector('input[data-name="Color"]:checked')?.value || "";
        const variant = getVariantData(variants, [Tallas, color]);
        const submitButton = boton.closest(".grid__item, .row_ccu-carrousel").querySelector(".quick-add__submit");
        addToCart(variant, submitButton);
      });
    });

    const botones_color_Tallas = target.querySelectorAll('input[data-name="Color"]:not(.initialized), input[data-name="Tallas"]:not(.initialized)');
    botones_color_Tallas.forEach(function (boton) {
      boton.classList.add('initialized');
      const variants = JSON.parse(
        boton.closest("variant-radios-card").querySelector("script").textContent
      );
      updateInit(boton, variants);
    });
  }

  // Ejecutar la función principal al cargar el documento
  handleProductVariants();

  // Configurar el MutationObserver
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            handleProductVariants(node);
          }
        });
      }
    });
  });

  // Iniciar la observación si productRelated existe
  if (productRelated) {
    observer.observe(productRelated, { childList: true, subtree: true });
  }

  function updateInit(boton, producto) {
    const Tallas = boton.closest("variant-radios-card")?.querySelector('input[data-name="Tallas"]:checked')?.value;
    const color = boton.closest("variant-radios-card")?.querySelector('input[data-name="Color"]:checked')?.value;
    const data = getVariantData(producto, [Tallas, color]);
    const price = boton.closest(".grid__item, .row_ccu-carrousel").querySelector(".price__sale .price-item");
    const compared_at_price = boton.closest(".grid__item, .row_ccu-carrousel").querySelector(".price__sale .price-item--regular");
    const variant_price = data?.price;
    const variant_compared_at_price = data?.compare_at_price;
    price.innerHTML = Shopify.formatMoney(
      variant_price,
      "{{amount_with_comma_separator}} €"
    );
    compared_at_price.innerHTML = Shopify.formatMoney(
      variant_compared_at_price,
      "{{amount_with_comma_separator}} €"
    );
    compared_at_price.style.display = variant_compared_at_price ? "inline" : "none";
  }

  function addToCart(variant, submitButton) {
    const variantInput = submitButton.closest("form").querySelector('input[name="id"]');
    variantInput.value = variant.id;
    submitButton.disabled = !variant.available;

    if (variant.available) {
      submitButton.click();
    }
  }

  function getVariant(variants, options) {
    return variants.find(variant => 
      options[1] === "" 
        ? variant.option1 === options[0]
        : variant.option2 === options[0] && variant.option1 === options[1]
    ) || null;
  }

  function getVariantData(variants, options) {
    const variant = getVariant(variants, options);
    if (!variant) return null;
    return {
      compare_at_price: variant.compare_at_price,
      price: variant.price,
      featured_image: variant.featured_image ? variant.featured_image.src : "",
      id: variant.id,
      available: variant.available
    };
  }
}

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    variantPicker();
  }, 500);
});